import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface LogsState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allLogs: [] | null | any;
}
const initialState: LogsState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allLogs: null,
};
export const logsSlice = createSlice({
  name: 'Logs',
  initialState,
  reducers: {
    setAllLogs: (state, action) => {
      state.allLogs = action.payload.data;
    },
    setLogs: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllLogs, setLogs, reset } = logsSlice.actions;
export const allLogsDetails = (state: RootState) => state.logs.allLogs;
export const getAllLogsDetails = (state: RootState) => state.logs.data;
export const getLogsTotalRecords=(state:RootState)=>state.logs.totalRecords;
export const getAllLogsBySearch = (state: RootState) => state.logs.data;
export default logsSlice.reducer;